var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"menu-item",attrs:{"to":_vm.to}},[_c('typo',{attrs:{"name":"menu-12-bold"}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }